module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ko":{"title":"리뷰 자세히 보기","product_button_label":"이 상품의 모든 리뷰 보기"}}')
  delete Component.options._Ctor
}
